import React, { useCallback, useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, Menu, MenuItem } from '@cicero/ui'
import { PageDoc, PageSchema, useModel } from '../../models'

export const PageContentDebugger = ({ page, onClose }: { page: PageDoc, onClose: () => void }) => {
  const [content, setContent] = useState('')

  useEffect(() => {
    const c = JSON.stringify(page.content, null, 2)
    setContent(c)
  }, [page])

  const saveContent = useCallback(async () => {
    const c = JSON.parse(content)
    await page.atomicSet('content', c)
    onClose()
  }, [content, onClose, page])

  return <div>
    <DialogContent>
      <textarea style={{ minWidth: '600px', minHeight: '600px' }} value={content} onChange={(e) => setContent(e.target.value)} />
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color="secondary" onClick={() => onClose()}>Cancel</Button>
      <Button variant="contained" color="primary" onClick={async () => saveContent()}>Save</Button>
    </DialogActions>
  </div>
}

export const PageActionsMenu = ({ page }: { page: PageDoc }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [debugOpen, setDebugOpen] = useState(false)
  const Pages = useModel(PageSchema)

  const handleClick = useCallback(e => setAnchorEl(e.currentTarget), [])
  const handleClose = useCallback(() => setAnchorEl(null), [])

  return <div>
    <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>Actions</Button>
    <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
      <MenuItem onClick={() => { handleClose(); Pages.DELETE(page) }}>Delete</MenuItem>
      <MenuItem onClick={() => { handleClose(); setDebugOpen(true) }}>Edit Content</MenuItem>
    </Menu>
    <Dialog open={debugOpen}>
      <PageContentDebugger page={page} onClose={() => setDebugOpen(false)} />
    </Dialog>
  </div>
}

export const PageDebugButton = ({ page }: { page: PageDoc }) => {
  const [debugOpen, setDebugOpen] = useState(false)

  return <>
    <Button onClick={() => setDebugOpen(true)}>Debug</Button>
    <Dialog open={debugOpen}>
      <PageContentDebugger page={page} onClose={() => setDebugOpen(false)} />
    </Dialog>
  </>
}

// const useStyles = makeStyles({

// })
